export default "__VITE_ASSET__BWupjCCc__"